<template>
  <div class="page-bar" v-if="show">
    <img class="page-bar__btn" src="./images/nav_second_icon_back@2x.png" @click="goBack" alt="">
    <div class="page-bar__title diandiandian-single">{{title}}</div>
    <span class="page-bar__btn"></span>
  </div>
</template>

<script>
import { env } from '@utils';
export default {
  props: {
    value: undefined,
    title: {
      type: String,
      default: ''
    },
    backEvent: undefined,
  },
  data() {
    return {
      isApp: env.isApp,
      show: false,
    };
  },
  created() {
    /**
     * cdkey 兑换码id
     * fullscreen 是否隐藏webview顶部工具条 1: 是
     */
    const { cdkey, fullscreen } = this.$route.query;
    if (typeof this.value === 'boolean') {
      this.show = this.value;
    } else {
      // 如果在app内， 默认不显示
      this.isApp && (this.show = false);
      // 如果在app内，且从兑换码进入，则显示
      this.isApp && fullscreen == 1 && cdkey && (this.show = true);
    }
  },
  watch: {
    value: {
      handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  methods: {
    goBack() {
      if (typeof (this.backEvent) === 'function') {
        this.backEvent();
        return;
      }
      window.history.back();
    }
  }
};
</script>

<style lang="stylus" scoped>
  .page-bar {
    position sticky;
    top: 0;
    display: flex;
    align-items: center;
    height 48px;
    padding: 44px 10px 0;
    line-height 48px;
    text-align center;
    background-color: #fff;
    font-size 18px;
    color #41414D;
    font-weight 500;
    .page-bar__title {
      flex 1
    }
    .page-bar__btn {
      width 32px;
      height 32px;
    }
  }
</style>
